import { getUniquenessValidator, nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { defaultMemberPaymentCardWalletCardTypes, memberPaymentCardWalletCardTypeValidator } from './card-type';
export const memberPaymentCardWalletConfigValidator = Validator.object({
    cardTypes: Validator.all([
        Validator.array({ minLength: 1, items: memberPaymentCardWalletCardTypeValidator }),
        getUniquenessValidator('id')
    ]),
    notification: Validator.object({ displayInline: Validator.boolean() }),
    redirectReturnUrl: Validator.optional(nonEmptyStringValidator),
    canRemoveCards: Validator.boolean(),
    showAddCardFormInline: Validator.boolean(),
    requirePrimaryCard: Validator.boolean()
});
export const defaultMemberPaymentCardWalletConfig = {
    cardTypes: defaultMemberPaymentCardWalletCardTypes,
    notification: {
        displayInline: true
    },
    redirectReturnUrl: undefined,
    canRemoveCards: true,
    showAddCardFormInline: true,
    requirePrimaryCard: false
};
